import type { FC } from 'react'
import type { RoadmapPhaseType } from '../atoms/RoadmapPhaseItem'
import { RoadmapPhaseItem } from '../atoms/RoadmapPhaseItem'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type RoadMapBlockProps = {
	roadmap: RoadmapPhaseType[]
}

export const RoadMapBlock: FC<RoadMapBlockProps> = ({ roadmap }) => {
	return (
		<ContentBlockWrapper blockTypes={['component']}>
			<div className="col-span-full">
				<div className="flex w-full flex-col tablet-l:flex-row tablet-l:items-stretch">
					{roadmap.map((phase, index) => (
						<RoadmapPhaseItem
							key={phase.id}
							phase={phase}
							layout={index % 2 === 0 ? 'default' : 'reverse'}
						/>
					))}
				</div>
			</div>
		</ContentBlockWrapper>
	)
}

export default RoadMapBlock
